// Utils
import { isEmpty } from '../../../../../common/utils/immutableHelper';
import { getElementId, getElementType } from '../../../../../common/elements/utils/elementPropertyUtils';
import {
    cardOrDocumentHasContent,
    columnHasContent,
    imageHasContent,
    linkHasContent,
    singleEditorTaskListHasContent,
} from '../../../../../common/elements/utils/elementTrashUtils';
import { isSingleEditorTaskList } from '../../../../../common/taskLists/taskListContentVersionUtils';

// Constants
import { ElementType } from '../../../../../common/elements/elementTypes';

const commentThreadHasComments = ({ element, commentsByThreadId }) => {
    const elementId = getElementId(element);
    const commentIds = commentsByThreadId[elementId];
    return !isEmpty(commentIds);
};

export const elementHasChildren = ({ element, elementGraph }) => {
    const elementId = getElementId(element);
    const childrenIds = elementGraph[elementId];
    return !isEmpty(childrenIds);
};

/**
 * A single-editor task list keeps its tasks in its own Tiptap content, so unlike a legacy task list
 * it has no child task elements to look for.
 */
export const taskListHasContent = ({ element, elementGraph }) =>
    isSingleEditorTaskList(element)
        ? singleEditorTaskListHasContent(element)
        : elementHasChildren({ element, elementGraph });

export const elementIsInterestingForTrash = ({ element, elementGraph, commentsByThreadId }) => {
    const elementType = getElementType(element);

    switch (elementType) {
        case ElementType.DOCUMENT_TYPE:
        case ElementType.CARD_TYPE:
            return cardOrDocumentHasContent(element);
        case ElementType.IMAGE_TYPE:
            return imageHasContent(element);
        case ElementType.LINK_TYPE:
            return linkHasContent(element);
        case ElementType.TASK_LIST_TYPE:
            return taskListHasContent({ element, elementGraph });
        case ElementType.COMMENT_THREAD_TYPE:
            return commentThreadHasComments({ element, commentsByThreadId });
        case ElementType.COLUMN_TYPE:
            return columnHasContent(element) || elementHasChildren({ element, elementGraph });
        case ElementType.BOARD_TYPE:
        case ElementType.ALIAS_TYPE:
        case ElementType.FILE_TYPE:
            return true;
        case ElementType.TASK_TYPE:
        case ElementType.LINE_TYPE:
            return false;
        default:
            return true;
    }
};
